import React, { useState } from 'react';
import { TermsModal } from './TermsModal';
import { PrivacyModal } from './PrivacyModal';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <>
      <footer className="py-8 px-4 text-center bg-[#0a0a0a] border-t border-white/5" data-id="element-30">
        <div className="flex flex-col items-center gap-4" data-id="element-31">
          <div className="flex items-center gap-6 text-sm text-brand-offwhite/60" data-id="element-32">
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-brand-amber transition-colors underline underline-offset-4" data-id="element-33">
              Términos y Condiciones
            </button>
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-brand-amber transition-colors underline underline-offset-4" data-id="element-34">
              Políticas de Privacidad
            </button>
          </div>
          <p className="text-sm text-brand-offwhite/40" data-id="element-35">
            © {new Date().getFullYear()} Después del Engaño. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-36" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-37" />
    </>;
}